import { IWorkerIdentSortValue } from "models";

export const EDIT_SUGOROKU_MODE = 'edit';
export const VIEW_SUGOROKU_MODE = 'view';
export const TOKYO_TZ = 'Asia/Tokyo';

export const workerIdentSortTypes: IWorkerIdentSortValue[] = [
    { id: 'asc', name: '全員（昇順）'},
    { id: 'desc', name: '全員（降順）'}
];